import { ref } from 'vue';
import PixtaAPI from 'custom/api/pixta';

// Whether the account is connected to Pixta, asked once and shared (the sidebar card shows only when it is)
const connection = ref(null);
let request = null;

export function usePixtaConnection() {
  const refresh = () => {
    request = PixtaAPI.connection()
      .then(({ data }) => {
        connection.value = data;
      })
      .catch(() => {
        connection.value = { configured: false };
      });
    return request;
  };
  if (!request) refresh();
  return { connection, refresh };
}
